import { render, staticRenderFns } from "./order-cancel-set.vue?vue&type=template&id=77023040&"
import script from "./order-cancel-set.vue?vue&type=script&lang=js&"
export * from "./order-cancel-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports